import { render, staticRenderFns } from "./CatalogoDePuntos.vue?vue&type=template&id=101779ce&scoped=true"
import script from "./CatalogoDePuntos.vue?vue&type=script&lang=js"
export * from "./CatalogoDePuntos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDePuntos.vue?vue&type=style&index=0&id=101779ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101779ce",
  null
  
)

export default component.exports